import React from 'react';

export interface IRoute {
    path: string;
    exact: boolean;
    name: string;
    loader: React.ReactNode
    component?: React.ComponentType<any>
    submenu?: IRoute[];
    isChild: boolean;
    hasLinkAccess:boolean;
    hasButtonAccess?:boolean;
}

// const detailsSubMenu: IRoute[] = [
//     {
//         path: '/clear-down',
//         exact: true,
//         name: 'Clear Down',
//         loader: () => import('./Components/Clear-Down')
//         isChild: false,
//         hasLinkAccess:verifyUserAccess('Clear Down')
//     },
//     {
//         path: '/email-account',
//         exact: true,
//         name: 'Email Account',
//         loader: () => import('./Components/Products'),
//         isChild: false,
//         hasLinkAccess:verifyUserAccess('Email Account')
//     },
//     {
//         path: '/pallet-details',
//         exact: true,
//         name: 'Pallet Details',
//         loader: () => import('./Components/Pallet-Detail'),
//         isChild: false,
//         hasLinkAccess:verifyUserAccess('Pallet Detail')
//     },
// ]

const routes: IRoute[] = [
    {
        path: '/purchaseorders',
        exact: true,
        name: 'Purchase Order',
        loader: () => import('./Components/PurchaseOrders'),
        component: React.lazy(() => import("./Components/PurchaseOrders")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/purchaseorders/:service',
        exact: true,
        name: 'Purchase Order',
        loader: () => import('./Components/PurchaseOrders/PurchaseOrder-Detail'),
        component: React.lazy(() => import("./Components/PurchaseOrders/PurchaseOrder-Detail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/storeorders',
        exact: true,
        name: 'Store Order',
        loader: () => import('./Components/Stores-Orders'),
        component: React.lazy(() => import("./Components/Stores-Orders")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/storeorders/:service',
        exact: true,
        name: 'Store Order',
        loader: () => import('./Components/Stores-Orders/StoreOrder-Detail'),
        component: React.lazy(() => import("./Components/Stores-Orders/StoreOrder-Detail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/journey',
        exact: true,
        name: 'Journey',
        loader: () => import('./Components/Transport-Schedule'),
        component: React.lazy(() => import("./Components/Transport-Schedule")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/journey/:service',
        exact: true,
        name: 'Journey',
        loader: () => import('./Components/Transport-Schedule/Journey-Detail'),
        component: React.lazy(() => import("./Components/Transport-Schedule/Journey-Detail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/loose-load-inventory',
        exact: true,
        name: 'Loose Load Inventory',
        loader: () => import('./Components/Loose-Load-Inventory'),
        component: React.lazy(() => import("./Components/Loose-Load-Inventory")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/loose-load-inventory/:service',
        exact: true,
        name: 'Loose Load Inventory',
        loader: () => import('./Components/Loose-Load-Inventory/LooseLoadDetail'),
        component: React.lazy(() => import("./Components/Loose-Load-Inventory/LooseLoadDetail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/address-table',
        exact: true,
        name: 'Address',
        loader: () => import('./Components/Address-Table'),
        component: React.lazy(() => import("./Components/Address-Table")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/address-table/:service',
        exact: true,
        name: 'Address',
        loader: () => import('./Components/Address-Table/Address-Detail'),
        component: React.lazy(() => import("./Components/Address-Table/Address-Detail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/skudetail',
        exact: true,
        name: 'SKU Detail',
        loader: () => import('./Components/SKU-Details'),
        component: React.lazy(() => import("./Components/SKU-Details")),
        isChild: false,
        hasLinkAccess:false
    },    
    {
        path: '/skudetail/:service',
        exact: true,
        name: 'SKU Detail',
        loader: () => import('./Components/SKU-Details/SKU-Detail'),
        component: React.lazy(() => import("./Components/SKU-Details/SKU-Detail")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/palletdetail',
        exact: true,
        name: 'Pallet Details',
        loader: () => import('./Components/Pallet-Detail'),
        component: React.lazy(() => import("./Components/Pallet-Detail")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/palletdetail/:service',
        exact: true,
        name: 'Pallet Details',
        loader: () => import('./Components/Pallet-Detail/Pallet-Detail-Sku'),
        component: React.lazy(() => import("./Components/Pallet-Detail/Pallet-Detail-Sku")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/file-upload',
        exact: true,
        name: 'File Upload',
        loader: () => import('./Components/File-Upload'),
        component: React.lazy(() => import("./Components/File-Upload")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/file-upload-history',
        exact: true,
        name: 'File Upload',
        loader: () => import('./Components/File-Upload/DataTable'),
        component: React.lazy(() => import("./Components/File-Upload/DataTable")),
        isChild: true,
        hasLinkAccess:false
    },
    {
        path: '/clear-down',
        exact: true,
        name: 'Clear Down',
        loader: () => import('./Components/Clear-Down'),
        component: React.lazy(() => import("./Components/Clear-Down")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/manage-contact',
        exact: true,
        name: 'Manage Contacts',
        loader: () => import('./Components/Manage-Contact'),
        component: React.lazy(() => import("./Components/Manage-Contact")),
        isChild: false,
        hasLinkAccess:false
    },
    {
        path: '/manage-contact/:service',
        exact: true,
        name: 'Manage Contacts',
        loader: () => import('./Components/Manage-Contact/Manage-Contact-Add-Edit'),
        component: React.lazy(() => import("./Components/Manage-Contact/Manage-Contact-Add-Edit")),
        isChild: true,
        hasLinkAccess:false
    },
]

export default routes;
